export class PredictionAcceptance {
  searchStrategyId: number;
  comparableIds: number[] = [];
  isFunctionPredictionMarkedAsComparable: boolean;
  isProductPredictionMarkedAsComparable: boolean;
  invalidateFunctionPredictionRerunInfo: boolean;
  invalidateProductPredictionRerunInfo: boolean;
}
